// src/hooks/useCartActions.ts
import { Order } from "@/interfaces/domain/menu";
import { useOrdersStore, useUIStore } from "../store";

export const useCartActions = () => {
  const config = useUIStore((s) => s.config);
  const setSection = useUIStore((s) => s.setSection);
  const clearOrders = useOrdersStore((s) => s.clear);

  const sendOrderToWhatsApp = (orders: Order[], total: number) => {
    const phone = config.phoneNumber?.replace(/\D/g, "");

    const orderId = crypto.randomUUID().substring(0, 8).toUpperCase();

    const message = `
 *Pedido Web Menugraphic*

*N° Pedido:* #${orderId}

*DETALLE DEL PEDIDO*

${orders
  .map((o) => {
    const base = `• ${o.title} x${o.quantity}`;

    const combos =
      o.comboSelection?.length
        ? "\n" +
          o.comboSelection
            .map((i: any) => `   * ${i.quantity}x ${i.title}`)
            .join("\n")
        : "";

    return `${base}${combos}`;
  })
  .join("\n\n")}

━━━━━━━━━━━━━━

 OBSERVACIONES:



━━━━━━━━━━━━━━

 Revisá bien tu pedido antes de enviarlo. Una vez enviado, el pedido y el total será confirmado por el local.
Muchas gracias!

`.trim();

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    clearOrders();
    setSection("home");
  };

  return { sendOrderToWhatsApp };
};


